module.exports = __webpack_public_path__ + "static/media/SOLACE.06edfdcb.png";